import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as projects from '../../projects'

export const RESOURCE = {
  payload: {
    description:
      'A sub-area that is addressed within a larger project. For example, within an ERP Transformation Project, there exist Data Conversion, Change Management, and Project Management areas.',
    dimension: projects.RESOURCE.payload,
    level: 1,
    name: 'Project Area',
    partialId: PartialId.Standard.create('proj_area'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
